export default "__VITE_ASSET__BsCxJ4PE__"